import { Component } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as fromCo2 from 'app/state/co2-bottle';
import { ICO2BottleVM } from 'app/models/co2-bottle';

@Component({
  selector: 'app-co2-picker',
  templateUrl: './co2.component.html',
  styleUrls: ['./co2.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class Co2PickerComponent {

  items = this.store.selectSignal(fromCo2.selectCO2BottlesNotInSelectedTower);

  constructor(
    private store: Store,
    private modalController: ModalController
  ) { }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async selectCo2(co2: ICO2BottleVM) {
    await this.modalController.dismiss(co2);
  }
}
